import { VisualIndicator } from "../types/diagnostics";

interface Props {
  state: VisualIndicator;
}

export default function AvatarIndicator({ state }: Props) {
  const configs: Record<string, { src: string; label: string; color: string }> = {
    excellent: {
      src: "/avatars/excellent.png",
      label: "Excellent",
      color: "text-emerald-600",
    },
    neutral: {
      src: "/avatars/neutral.png",
      label: "Healthy",
      color: "text-strivre-burgundy",
    },
    poor: {
      src: "/avatars/poor.png",
      label: "Needs Work",
      color: "text-amber-600",
    },
    critical: {
      src: "/avatars/critical.png",
      label: "Critical",
      color: "text-red-600",
    },
  };

  // Fallback to 'neutral' if state is missing or doesn't match our keys
  const normalizedState = (state || "neutral").toLowerCase();
  const config = configs[normalizedState] || configs.neutral;

  return (
    <div className="flex flex-col items-center gap-2">
      <img 
        src={config.src} 
        alt={config.label} 
        className="w-56 h-56 sm:w-64 sm:h-64 lg:w-72 lg:h-72 object-contain animate-bounce-slight drop-shadow-xl"
      />
      <span className={`text-[10px] font-black uppercase tracking-[0.2em] ${config.color}`}>
        {config.label}
      </span>
    </div>
  );
}
